import { h as __h } from "preact";
import { Component } from "preact";
import html from "~/util/html.js";
import Icon from "~/component/Icon.js";
import Popover from "~/component/Popover.js";
import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./Switcher.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./Switcher.module.css", import.meta.url);
const css = adopt(sheet);

/**
 * @typedef {object} Section
 * @property {string} label
 * @property {string} description
 * @property {string} icon
 * @property {string} [href]
 * @property {() => void} [onSelect]
 */

/**
 * @extends {Component<Props>}
 *
 * @typedef {object} Props
 * @property {Section} current
 * @property {Section[]} [sections]
 */
export default class Switcher extends Component {
  /** @param {PointerEvent & { currentTarget: HTMLDivElement }} ev */
  #onPopoverClick = ev => {
    if (ev.target instanceof Element && ev.target.closest("a, button")) ev.currentTarget.hidePopover();
  };
  render() {
    const {
      current,
      sections = []
    } = this.props;
    const contents = [__h(Icon, {
      name: "phaze",
      size: 24
    }), __h("span", {
      "class": css.label
    }, __h("span", {
      "class": css.wordmark
    }, "Phaze"), __h("span", {
      "class": css.section
    }, current.label))];
    const trigger = __h("button", {
      type: "button",
      "class": css.switcher,
      popovertarget: "section-switcher"
    }, contents, __h("span", {
      "class": css.arrow
    }, __h(Icon, {
      name: "down-filled",
      size: 12
    })));
    if (sections.length) {
      return __h(Popover, {
        id: "section-switcher",
        placement: "bottom-start",
        trigger: trigger,
        onClick: this.#onPopoverClick
      }, __h("nav", {
        "class": css.options,
        "aria-label": "Switch to"
      }, sections.map(section => {
        const tag = section.onSelect ? "button" : "a";
        return __h(tag, {
          key: section.label,
          type: section.onSelect && "button",
          "class": css.option,
          href: section.href,
          onClick: section.onSelect,
          "aria-current": section.href === current.href ? "page" : undefined
        }, __h("span", {
          "class": css.tile
        }, __h(Icon, {
          name: section.icon,
          size: 16
        })), __h("span", {
          "class": css.optionLabel
        }, section.label), __h("span", {
          "class": css.description
        }, section.description));
      })));
    }
    return __h("a", {
      "class": css.switcher,
      href: current.href
    }, contents);
  }
}